import { styled } from 'styled-components';
import { Button } from '../Button.js';
import { cssVar } from '../../theme/variables.js';

const SmallControlButton = styled(Button).attrs((props) => {
  return {
    variant: "bg-secondary",
    ...props
  };
}).withConfig({
  displayName: "SmallControlButton",
  componentId: "sc-83951dee-0"
})([
  `height:29px;padding:0 6px;gap:6px;border-radius:6px;font-size:14px;color:`,
  `;`
], cssVar["color-text-tertiary"]);

export { SmallControlButton };
//# sourceMappingURL=SmallControlButton.js.map
